// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__14HBP","inner":"Footer_inner__1JaPo"};